import {validate} from '@wix/wix-events-commons-statics'
import {reduxForm} from 'redux-form'
import {RegFormData} from '../../types/registration'
import {REGISTRATION_FORM_ID} from './constants'
import {Form as FormComponent} from './form'
import {FormOwnProps} from './interfaces'
import {onSubmitFail} from './utils'

export const Form = reduxForm<RegFormData, FormOwnProps>({
  form: REGISTRATION_FORM_ID,
  destroyOnUnmount: false,
  validate,
  onSubmitFail,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(FormComponent)
